/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WizardValidationErrorDto } from './WizardValidationErrorDto';
import {
    WizardValidationErrorDtoFromJSON,
    WizardValidationErrorDtoFromJSONTyped,
    WizardValidationErrorDtoToJSON,
    WizardValidationErrorDtoToJSONTyped,
} from './WizardValidationErrorDto';
import type { WizardPreviewSummaryDto } from './WizardPreviewSummaryDto';
import {
    WizardPreviewSummaryDtoFromJSON,
    WizardPreviewSummaryDtoFromJSONTyped,
    WizardPreviewSummaryDtoToJSON,
    WizardPreviewSummaryDtoToJSONTyped,
} from './WizardPreviewSummaryDto';
import type { WizardWarningDto } from './WizardWarningDto';
import {
    WizardWarningDtoFromJSON,
    WizardWarningDtoFromJSONTyped,
    WizardWarningDtoToJSON,
    WizardWarningDtoToJSONTyped,
} from './WizardWarningDto';
import type { AssignmentConflictResponseDto } from './AssignmentConflictResponseDto';
import {
    AssignmentConflictResponseDtoFromJSON,
    AssignmentConflictResponseDtoFromJSONTyped,
    AssignmentConflictResponseDtoToJSON,
    AssignmentConflictResponseDtoToJSONTyped,
} from './AssignmentConflictResponseDto';

/**
 * 
 * @export
 * @interface PreviewPlanFromWizardResponseDto
 */
export interface PreviewPlanFromWizardResponseDto {
    /**
     * 
     * @type {Array<WizardValidationErrorDto>}
     * @memberof PreviewPlanFromWizardResponseDto
     */
    validationErrors: Array<WizardValidationErrorDto>;
    /**
     * 
     * @type {Array<AssignmentConflictResponseDto>}
     * @memberof PreviewPlanFromWizardResponseDto
     */
    conflicts: Array<AssignmentConflictResponseDto>;
    /**
     * 
     * @type {Array<WizardWarningDto>}
     * @memberof PreviewPlanFromWizardResponseDto
     */
    warnings: Array<WizardWarningDto>;
    /**
     * 
     * @type {WizardPreviewSummaryDto}
     * @memberof PreviewPlanFromWizardResponseDto
     */
    summary: WizardPreviewSummaryDto;
}

/**
 * Check if a given object implements the PreviewPlanFromWizardResponseDto interface.
 */
export function instanceOfPreviewPlanFromWizardResponseDto(value: object): value is PreviewPlanFromWizardResponseDto {
    if (!('validationErrors' in value) || value['validationErrors'] === undefined) return false;
    if (!('conflicts' in value) || value['conflicts'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function PreviewPlanFromWizardResponseDtoFromJSON(json: any): PreviewPlanFromWizardResponseDto {
    return PreviewPlanFromWizardResponseDtoFromJSONTyped(json, false);
}

export function PreviewPlanFromWizardResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewPlanFromWizardResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'validationErrors': ((json['validationErrors'] as Array<any>).map(WizardValidationErrorDtoFromJSON)),
        'conflicts': ((json['conflicts'] as Array<any>).map(AssignmentConflictResponseDtoFromJSON)),
        'warnings': ((json['warnings'] as Array<any>).map(WizardWarningDtoFromJSON)),
        'summary': WizardPreviewSummaryDtoFromJSON(json['summary']),
    };
}

export function PreviewPlanFromWizardResponseDtoToJSON(json: any): PreviewPlanFromWizardResponseDto {
    return PreviewPlanFromWizardResponseDtoToJSONTyped(json, false);
}

export function PreviewPlanFromWizardResponseDtoToJSONTyped(value?: PreviewPlanFromWizardResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validationErrors': ((value['validationErrors'] as Array<any>).map(WizardValidationErrorDtoToJSON)),
        'conflicts': ((value['conflicts'] as Array<any>).map(AssignmentConflictResponseDtoToJSON)),
        'warnings': ((value['warnings'] as Array<any>).map(WizardWarningDtoToJSON)),
        'summary': WizardPreviewSummaryDtoToJSON(value['summary']),
    };
}

